import hrms31eLabels from 'assets/labels/hrms31e'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hrms31eLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockRows.push({
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        codcomp: '',
        desc_codcomp: faker.name.jobType(),
        codpos: '',
        desc_codpos: faker.name.title(),
        typproba: '',
        desc_typproba: 'probation',
        dteoccup: moment().format('DD/MM/YYYY'),
        dteduepr: moment().format('DD/MM/YYYY'),
        staappr: '',
        desc_staupd: mockStatus[staappr],
        numseq: faker.random.number().toString().substr(0, 1),
        flgedit: 'Y'
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      typproba: 'ทดลองงาน',
      qtyasg: faker.random.number().toString().substr(0, 1),
      qtyapp: faker.random.number().toString().substr(0, 1),
      dteempmt: moment().format('DD/MM/YYYY'),
      dteduepr: moment().format('DD/MM/YYYY'),
      dteeval: moment().format('DD/MM/YYYY'),
      scorepr: faker.random.number().toString().substr(0, 2),
      codrespr: '1',
      qtyexpand: faker.random.number().toString().substr(0, 2),
      desnote: faker.random.words(),
      codexemp: '0001',
      desc_codexemp: faker.random.words(),
      flgappr: 'P'
    }
    let mockTab2 = {
      codform: faker.random.word(),
      desc_codform: faker.random.words()
    }
    let mockTab2Table2Rows = []
    const mockChoice = [ 'A', 'B', 'C', 'D' ]
    const mockDescChoice = [ 'Excellence', 'Good', 'Normal', 'Bad' ]
    const mockScore = [ '4', '3', '2', '1' ]
    const mockTab2Table2Total = 4
    for (var d = 1; d <= mockTab2Table2Total; d++) {
      mockTab2Table2Rows.push({
        graditem: d,
        grad: mockChoice[d - 1],
        qtyscor: mockScore[d - 1],
        desc_graditem: mockDescChoice[d - 1],
        definit: ''
      })
    }
    let mockTab2Table1GroupRows = []
    const mockTab2Table1Total = 3
    for (var a = 1; a <= mockTab2Table1Total; a++) {
      let mockTab2Table1ItemRows = []
      const mockTab2Table1ItemTotal = 3
      let mockGroupQtyfscor = 0
      let mockGroupQtyscor = 0
      for (var e = 1; e <= mockTab2Table1ItemTotal; e++) {
        let mockItemQtywgt = Math.floor(Math.random() * 5) + 1
        let mockItemQtyfscor = 4 * mockItemQtywgt
        let mockItemGraditem = Math.floor(mockItemQtyfscor * Math.random())
        let mockItemQtyscor = mockItemGraditem * mockItemQtywgt
        let mockChoiceFiltered = mockTab2Table2Rows.filter((choice) => {
          return choice.graditem === mockItemGraditem
        })
        let mockGrad = ''
        if (mockChoiceFiltered.length > 0) {
          mockGrad = mockChoiceFiltered[0].grad
        }
        mockTab2Table1ItemRows.push({
          numitem: e,
          desc_numitem: 'description ',
          definit: 'Sub description',
          qtyfscor: mockItemQtyfscor,
          qtyscor: mockItemQtyscor,
          graditem: mockItemGraditem,
          grad: mockGrad,
          qtywgt: mockItemQtywgt
        })
        mockGroupQtyfscor += mockItemQtyfscor
        mockGroupQtyscor += mockItemQtyscor
      }
      mockTab2Table1GroupRows.push({
        numgrup: a,
        desc_numgrup: 'หัวข้อเรื่อง',
        qtyfscor: mockGroupQtyfscor,
        qtyscor: mockGroupQtyscor,
        numitem: mockTab2Table1ItemRows
      })
    }
    let mockTab3 = {
      dtest: '',
      dteen: '',
      qtytlate: '0',
      qtylate: faker.random.number().toString().substr(0, 1) + ':' + moment().format('HH:mm'),
      qtytearly: '0',
      qtyearly: faker.random.number().toString().substr(0, 1) + ':' + moment().format('HH:mm'),
      qtytabs: faker.random.number().toString().substr(0, 2),
      qtyabsent: faker.random.number().toString().substr(0, 1) + ':' + moment().format('HH:mm')
    }
    let mockTab3Rows1 = []
    const mockTab3Total1 = 7
    for (var b = 1; b <= mockTab3Total1; b++) {
      mockTab3Rows1.push({
        typleave: faker.random.word(),
        desc_typleave: faker.random.words(),
        numleave: faker.random.number().toString().substr(0, 1) + ':' + moment().format('HH:mm')
      })
    }
    let mockTab3Rows2 = []
    const mockTab3Total2 = 2
    for (var c = 1; c <= mockTab3Total2; c++) {
      mockTab3Rows2.push({
        dteeffec: moment().format('DD/MM/YYYY'),
        desmist1: faker.random.words()
      })
    }

    return {
      tab1: mockTab1,
      tab2: {
        detail: mockTab2,
        table1: {
          total: mockTab2Table1Total,
          rows: mockTab2Table1GroupRows
        },
        table2: {
          total: mockTab2Table2Total,
          rows: mockTab2Table2Rows
        }
      },
      tab3: {
        detail: mockTab3,
        table1: {
          total: mockTab3Total1,
          rows: mockTab3Rows1
        },
        table2: {
          total: mockTab3Total2,
          rows: mockTab3Rows2
        }
      }
    }
  },
  detailTab3Search () {
    let mockTab3 = {
      dtest: moment().format('DD/MM/YYYY'),
      dteen: moment().format('DD/MM/YYYY'),
      qtytlate: '0',
      qtylate: faker.random.number().toString().substr(0, 1) + ':' + moment().format('HH:mm'),
      qtytearly: '0',
      qtyearly: faker.random.number().toString().substr(0, 1) + ':' + moment().format('HH:mm'),
      qtytabs: faker.random.number().toString().substr(0, 2),
      qtyabsent: faker.random.number().toString().substr(0, 1) + ':' + moment().format('HH:mm')
    }
    let mockTab3Rows1 = []
    const mockTab3Total1 = 7
    for (var b = 1; b <= mockTab3Total1; b++) {
      mockTab3Rows1.push({
        typleave: faker.random.word(),
        desc_typleave: faker.random.words(),
        numleave: faker.random.number().toString().substr(0, 1) + ':' + moment().format('HH:mm')
      })
    }
    let mockTab3Rows2 = []
    const mockTab3Total2 = 2
    for (var c = 1; c <= mockTab3Total2; c++) {
      mockTab3Rows2.push({
        dteeffec: moment().format('DD/MM/YYYY'),
        desmist1: faker.random.words()
      })
    }

    return {
      detail: mockTab3,
      table1: {
        total: mockTab3Total1,
        rows: mockTab3Rows1
      },
      table2: {
        total: mockTab3Total2,
        rows: mockTab3Rows2
      }
    }
  },
  dropdowns () {
    const mockCodrespr = {
      '1': 'ผ่าน',
      '2': 'ไม่ผ่าน',
      '3': 'ขยายเวลา'
    }
    const mockCodexemp = {
      '0001': 'ลาออก',
      '0002': 'เกษียณอายุ',
      '0003': 'ตาย',
      '0004': 'ไล่ออก',
      '0005': 'N/A',
      '1001': 'ศึกษาต่อ',
      '1002': 'ประกอบธุรกิจส่วนตัว',
      '1003': 'มีปัญหาเรื่องสุขภาพ',
      'G001': 'ทดสอบ ทุจริต'
    }

    return {
      codrespr: {
        en: mockCodrespr,
        th: mockCodrespr
      },
      codexemp: {
        en: mockCodexemp,
        th: mockCodexemp
      }
    }
  },
  popupDetail () {
    return {
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      v_department: faker.random.word(),
      v_dteempmt: moment().format('DD/MM/YYYY'),
      v_position: faker.random.word(),
      dtereemp: moment().format('DD/MM/YYYY'),
      v_jobcode: faker.lorem.word(),
      v_days: faker.random.number().toString().substr(0, 2),
      v_descempmt: faker.random.word(),
      dte_show: moment().format('DD/MM/YYYY'),
      v_typeemp: faker.random.word(),
      v_descpro: faker.random.word()
    }
  },
  save () {
    return labels.mockPostMessage
  },
  cancel () {
    return labels.mockPostMessage
  },
  sendMail () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms31e/mocker.js